import { render, staticRenderFns } from "./CreditsTable.vue?vue&type=template&id=15dcb314&scoped=true&"
import script from "./CreditsTable.vue?vue&type=script&lang=js&"
export * from "./CreditsTable.vue?vue&type=script&lang=js&"
import style0 from "./CreditsTable.vue?vue&type=style&index=0&id=15dcb314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcb314",
  null
  
)

export default component.exports